import { render, staticRenderFns } from "./OnlineOrderingStyle.vue?vue&type=template&id=744f8c28&scoped=true"
import script from "./OnlineOrderingStyle.vue?vue&type=script&lang=js"
export * from "./OnlineOrderingStyle.vue?vue&type=script&lang=js"
import style0 from "./OnlineOrderingStyle.vue?vue&type=style&index=0&id=744f8c28&prod&lang=scss&scoped=true"
import style1 from "./OnlineOrderingStyle.vue?vue&type=style&index=1&id=744f8c28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744f8c28",
  null
  
)

export default component.exports